import Repository from "./Repository";

const endpoint = "/teachers";

export default {
  createTeacher: (payload) => Repository.post(`${endpoint}/`, payload),
  listTeachers: (params) => Repository.get(`${endpoint}/`, { params: params }),
  getTeacher: (id) => Repository.get(`${endpoint}/${id}/`),
  updateTeacher: (id, payload) =>
    Repository.patch(`${endpoint}/${id}/`, payload),
  deleteTeacher: (id) => Repository.delete(`${endpoint}/${id}/`),
  subscribe: (id) => Repository.get(`${endpoint}/${id}/subscribe/`),
  unsubscribe: (id) => Repository.get(`${endpoint}/${id}/unsubscribe/`),
  checkSubscription: (id) =>
    Repository.get(`${endpoint}/${id}/check_subscription/`),
  getTeacherStudents: (id) => Repository.get(`${endpoint}/${id}/get_students/`),
  getStudentsForTeachers: (payload) =>
    Repository.post(`${endpoint}/get_students_for_teachers/`, payload),
  getTeacherSchools: (id) => Repository.get(`${endpoint}/${id}/get_schools/`),
  setGradingSystem: (id, payload) =>
    Repository.patch(`${endpoint}/${id}/set_grading_system/`, payload),
};
